import React from 'react';
// import loadable from '@loadable/component';
import { Navigate, createBrowserRouter, useLocation } from 'react-router-dom';

// import { motion } from 'framer-motion';
// import { getTrackedResume } from '../api';
// import {
//   CreationFlow,
//   ImportFlow,
// } from '../components/common/Form/settings/basic';
// import {
//   withPermissionGuard,
//   // withPreventDirectAccessGuard,
// } from '../components/HOCs';

// for Code Splitting
// const Login = loadable(() => import('../views/login')); // User Flow_註冊_鳳梨專屬入口（測試用)
import DefaultLayout from '../layouts/defaultLayout'
import Homepage from '../pages/index'
import Indetity from '../pages/identity'
import Services from '../pages/services'
import Add from '../pages/add'
import Track from '../pages/track';

// const DefaultLayout = loadable(() => import('../layouts/defaultLayout'));
// const DefaultLayout = () => import('../layouts/defaultLayout');
// const Homepage = () => import('../pages/index');
// const Homepage = loadable(() => import('../pages/index'));
// const Dashboard = loadable(() => import('../views/dashboard'));
// const Dashboard2 = loadable(() => import('../views/dashboard2'));

// const Map = loadable(() => import('../views/map'));
// const Boundary = loadable(() => import('../views/boundary'));
// const ProtectedProfile = withPreventDirectAccessGuard(Profile);

// const GuardedDefaultLayout = withPermissionGuard(DefaultLayout);
// const GuardedMap = withPermissionGuard(Map);

const NotFound = () => {
  const location = useLocation();

  return (
    <main style={{ padding: '1em' }}>
      <p>
        Route: "{decodeURIComponent(location.pathname)}" -&gt; 404 Not Found{' '}
      </p>
    </main>
  );
};

const router = createBrowserRouter(
  [
    // { path: '/login', element: <Login /> },
    {
      path: '/',
      // element: <GuardedDefaultLayout allowedRoles={true} />,
      element: <DefaultLayout />,
      children: [
        // {
        //   index: true,
        //   element: <Navigate to="dashboard" replace />,
        // },
        {
          path: '',
          element: <Homepage />,
        },
        {
          path: 'identity',
          element: <Indetity />,
        },
        {
          path: 'services',
          element: <Services />,
        },
        {
          path: 'add',
          element: <Add />,
        },
        {
          path: 'track',
          element: <Track />,
        },
        
        // {
        //   path: 'planting',
        //   element: <Planting2 />,
        //   children: [
        //     {
        //       index: true,
        //       element: <Navigate to="region" replace />,
        //     },
        //     {
        //       path: 'region',
        //       element: <Region />,
        //       children: [
        //         {
        //           path: 'create',
        //           element: <RegionInnerPage />,
        //         },
        //         {
        //           path: 'dispatch',
        //           element: <DispatchInnerPage />,
        //         },
        //       ],
        //     },
        //     {
        //       path: 'estimation',
        //       element: <Estimation />,
        //     },
        //   ],
        // },
      
        // {
        //   path: 'settings',
        //   element: <Settings />,
        //   children: [
        //     {
        //       index: true,
        //       element: <Navigate to="basic" replace />,
        //     },
        //     {
        //       path: 'basic',
        //       element: <Basic />,
        //       children: [
        //         {
        //           path: 'import/*',
        //           element: (
        //             <motion.div
        //               key="flow-overlay"
        //               className="i-plant-overlay"
        //               initial={{ opacity: 0 }}
        //               animate={{ opacity: 1 }}
        //               transition={{ duration: 0.1 }}
        //             >
        //               <ImportFlow />
        //             </motion.div>
        //           ),
        //         },
        //         {
        //           path: 'create/*',
        //           element: (
        //             <motion.div
        //               key="flow-overlay"
        //               className="i-plant-overlay"
        //               initial={{ opacity: 0 }}
        //               animate={{ opacity: 1 }}
        //               transition={{ duration: 0.1 }}
        //             >
        //               <CreationFlow />
        //             </motion.div>
        //           ),
        //         },
        //         {
        //           path: 'profile',
        //           element: (
        //             // <ProtectedProfile
        //             //   accessiblePatterns={['']}
        //             //   buttonText="返回"
        //             //   callback={({ navigate, previousPathname }) => {
        //             //     navigate(previousPathname || '/settings/basic');
        //             //   }}
        //             // />
        //             <Profile />
        //           ),
        //         },
        //       ],
        //     },
        //     {
        //       path: 'account',
        //       element: <div>Account</div>,
        //     },
        //     {
        //       path: 'notification',
        //       element: <div>Notification</div>,
        //     },
        //   ],
        // },
        
        {
          path: '*',
          element: <NotFound />,
        },
      ],
    },
    
    // {
    //   path: '/map',
    //   element: <GuardedMap />,
    // },
    // {
    //   path: '/tracking',
    //   children: [
    //     {
    //       path: ':packageNo',
    //       element: <Tracking />,
    //       loader: async ({ params: { packageNo } }) => {
    //         return getTrackedResume({ packageNo });
    //       },
    //     },
    //     {
    //       path: '*',
    //       element: <NotFound />,
    //     },
    //   ],
    // },
    // {
    //   path: '/invite',
    //   element: <Invite />,
    //   children: [
    //     {
    //       path: 'receive',
    //       element: <InviteReceive />,
    //     },
    //     {
    //       path: 'reject',
    //       element: <InviteReject />,
    //     },
    //     // {
    //     //   path: '*',
    //     //   element: <NotFound />,
    //     // },
    //   ],
    // },
    // {
    //   path: '/privacy',
    //   element: <Privacy />,
    // },
    // {
    //   path: '/boundary',
    //   element: <Boundary />,
    // },
   
    // {
    //   path: '/customer/print',
    //   element: <CustomerPrint />,
    // },
    // {
    //   path: '/customer/inform',
    //   element: <CustomerInform />,
    // },
  ],
  { basename: process.env.PUBLIC_URL }
);

export default router;
